<template>
    <div class="p-3 flex">
      <div class="flex-1 text-left"><slot/></div>
      <div>
        <button v-for="item in languages" :key="item.title" @click="changeLocale(item.language)"> 
        <country-flag :country="item.flag" size='small'/> 
     </button> 
    </div>
</div>  
</template>


<script>

import {i18n} from '@/plugins/i18n';

export default {
  name: "LToolbar",
  data() {
    return {
      languages: [
          { flag: 'us', language: 'en', title: 'English' },
          { flag: 'no', language: 'no', title: 'Norsk' }
      ]
    }
  },
  methods: {
    changeLocale(locale) {
        i18n.locale = locale;
        this.$emit('updatelocale', locale); //necessary for publicweb to catch the update 
        this.$root.$emit('rendertable'); //call for table header update
        
    }
  }
};
</script>

